module.exports = __webpack_public_path__ + "img/peizhi.09bc1fff.svg";